export default __webpack_public_path__ + "static/media/articledashboard.5c0e2909.svg";